<script setup>
import { ref, computed } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import PremiumTabs from '@/Components/PremiumTabs.vue';
import Buttons from '@/Components/Buttons.vue';
import {
    mdiPlusCircle,
    mdiCheckBold,
    mdiTrashCan,
    mdiPlusThick,
    mdiCreditCard,
    mdiCashMultiple,
    mdiBank,
    mdiBroom
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import BaseIcon from "@/Components/BaseIcon.vue";
import VueSelect from "vue3-select-component";

defineProps({
    datalist: Array,
    columnas: Array,
    tallas: Object,
    isAdmin: Boolean,
    canRead: Boolean,
    canCreate: Boolean,
    userParam: Object
});

const rutaPrefijo = ref('product');
const modulo = ref('product');
const modulos = ref('Productos'); // <-- Descripción en la parte superior de la tabla
const tab = ref(0);
const id_student = ref(0)

const tabsMenu = computed(() => [
    { id: 0, label: 'Productos', icon: 'tabler:box', show: true },
    { id: 1, label: 'Ventas', icon: 'tabler:shopping-cart', show: true }
]);

// Now date
let now = new Date();
let month = (now.getMonth() + 1);
let day = now.getDate();
if (month < 10)
    month = "0" + month;
if (day < 10)
    day = "0" + day;
let today = now.getFullYear() + '-' + month + '-' + day;

const dateNow = ref(today);

</script>

<template>

    <Head title="Productos" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PremiumPageHeader title="Productos" subtitle="Gestión de inventario y registro de ventas." icon="tabler:package" color="indigo" :actionsOnBottomOnMobile="false">
                <template #actions>
                    <Buttons v-if="tab == 0" label="Nuevo Producto" icon="f7:plus-app-fill" size="vuexy" color="blue" :href="route(rutaPrefijo + '-create')" hideLabelOnMobile />
                </template>
                <template #bottom>
                    <PremiumTabs v-model="tab" :tabs="tabsMenu" />
                </template>
            </PremiumPageHeader>
        </template>

        <div v-if="tab == 0">
            <div class="bg-white overflow-hidden border shadow-lg rounded-md p-4">

                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                <CardBox v-if="datalist.length" has-table>
                    <!-- Tablesingle opciones: checkable opción para cambiar precio sería dentro -->
                    <div class="w-full overflow-x-auto relative">
                        <TableAdvanced :modulo="modulo" :modulos="modulos" :userParam="userParam" :data="datalist" :fields="columnas" :ruta="rutaPrefijo" exporteable visualable checkable searchAdvance :changeOption1="(isAdmin ? true : false)" />
                    </div>

                </CardBox>
                <CardBox v-else>
                    <CardBoxComponentEmpty />
                </CardBox>

            </div>
        </div>
        <div v-if="tab == 1">


            <div class="grid grid-cols-6 gap-4 bg-white rounded-lg overflow-hidden shadow-lg border">

                <div class="col-span-6 p-4 pb-0">
                    <VueSelect v-model="id_student" class="select-search-light" :options="[
                        { label: 'Juan', value: '1' },
                        { label: 'Jose', value: '2' },
                        { label: 'Juana', value: '3' },
                        { label: 'Josefina', value: '4' },
                        { label: 'Jacinto', value: '5' },
                        { label: 'Jesus', value: '6' },
                        { label: 'Jeiner', value: '7' },
                    ]" placeholder="Seleccione un alumno" />
                </div>


                <!-- <div class="col-span-6 px-6 pb-0">
                        <div class="flex lg:flex-wrap lg:justify-end gap-4">
                            <div class="w-1/2 lg:w-1/4">
                                <p class="text-xs pb-1">Tiempo Total</p>
                                <p class="bg-gray-100 p-2 border rounded-md text-sm">0 m.</p>
                            </div>
                            <div class="w-1/2 lg:w-1/4">
                                <p class="text-xs pb-1">Tiempo Total</p>
                                <p class="bg-gray-100 p-2 border rounded-md text-sm">0 m.</p>
                            </div>
                        </div>
                    </div> -->

                <div class="col-span-6">
                    <div class="grid grid-cols-12 bg-gray-700 text-white text-sm lg:text-base gap-2 py-2 px-2 lg:px-6">

                        <div class="col-span-6 lg:col-span-7">Descripción</div>
                        <div class="col-span-2 text-center">Cant.</div>
                        <div class="col-span-3 lg:col-span-2 text-center">Precio</div>
                        <div class="col-span-1 text-center"></div>
                    </div>
                    <div class="grid grid-cols-12 bg-white text-sm lg:text-base gap-2 py-2 px-2 lg:px-6 border-b border-b-gray-300">
                        <div class="col-span-6 lg:col-span-7">Polo blanco talla 10</div>
                        <div class="col-span-2 text-center">1</div>
                        <div class="col-span-3 lg:col-span-2 text-center">S/ 30.00</div>
                        <div class="col-span-1 h-[20px] text-center">
                            <BaseIcon :path="mdiTrashCan" size="20" w="20" h="20" class="text-rose-600" />
                        </div>
                    </div>
                    <!-- <div
                            class="grid grid-cols-12 bg-gray-100 lg:text-base gap-2 py-2 border-b px-2 lg:px-6 border-b-gray-300">
                            <div class="col-span-12">No hay items añadidos</div>
                        </div> -->
                </div>

                <div class="col-span-6">
                    <div class="grid grid-cols-12 bg-white gap-2 py-2 px-2 lg:px-6">

                        <div class="col-span-12 lg:col-span-5">
                            <p class="text-sm pb-1">Descripción</p>

                            <select id="countries" class="w-full">
                                <option selected>seleccionar producto</option>
                                <option value="1">Buzo completo talla M</option>
                                <option value="2">Karate talla S</option>
                                <option value="3">Polo blanco talla 10</option>
                            </select>
                        </div>
                        <div class="col-span-4 lg:col-span-2">
                            <p class="text-sm pb-1">Dscto. M.</p>
                            <input type="text" value="0" class="w-full">
                        </div>
                        <div class="col-span-4 lg:col-span-2">
                            <p class="text-sm pb-1">Cantidad</p>
                            <input type="text" value="1" class="w-full">
                        </div>
                        <div class="col-span-4 lg:col-span-2">
                            <p class="text-sm pb-1">Precio</p>
                            <input type="text" value="0" class="w-full">
                        </div>
                    </div>
                </div>
                <div class="col-span-6 px-4">
                    <div class="grid grid-cols-4 gap-4">
                        <div class="col-span-4 lg:col-span-1 lg:col-start-4">
                            <button class="btn btn-rose btn-ico w-full">
                                <span class="mr-2">Añadir</span>
                                <BaseIcon :path="mdiPlusThick" />
                            </button>
                        </div>

                    </div>
                    <!-- <div class="flex lg:flex-wrap justify-end gap-2 mb-3">
                            <div class="w-full lg:w-1/4">
                                <button class="btn btn-rose btn-ico w-full justify-center">
                                    <span class="mr-2">Añadir</span>
                                    <BaseIcon :path="mdiPlusThick" />
                                </button>
                            </div>
                        </div> -->
                </div>
                <div class="col-span-6 px-4 pb-4">
                    <div class="grid grid-cols-4 gap-4">
                        <div class="col-span-2 lg:col-span-1 flex items-center">
                            <!-- <p class="bg-gray-100 p-2 border rounded-md w-full text-sm lg:text-base  h-[40px]">Monto de Pago</p> -->
                            <input type="text" value="30" class="w-full" placeholder="Monto de Pago">
                        </div>
                        <div class="col-span-2 lg:col-span-1">
                            <input type="text" class="w-full" placeholder="Detalle / Operación">
                        </div>
                        <div class="col-span-2 lg:col-span-1 flex items-center">
                            <input type="date" :value="dateNow" class="w-full " placeholder="Fecha de pago">
                        </div>
                        <div class="col-span-2 lg:col-span-1">
                            <button class="btn btn-blue btn-ico w-full">
                                <span class="mr-2">Confirmar</span>
                                <BaseIcon :path="mdiCheckBold" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Forma de pago Radio button -->
            <!-- <div class="container sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                <div class="grid grid-cols-1 lg:grid-cols-6 gap-4 bg-white p-6 rounded-lg overflow-hidden shadow-lg">
                    <div class="col-span-6">
                        <h1 class="text-gray-900 text-xl font-bold">Tipo de pago
                        </h1>
                    </div>
                    <div class="col-span-6">
                        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
                            <div class="flex items-center justify-between border rounded-md">
                                <label for="estandar1" class="grid w-full p-4">
                                    <div class="flex items-center">
                                        <BaseIcon :path="mdiCreditCard" :size="40" :w="20" :h="20"
                                            class="text-green-600 mr-3" />
                                        <span class="fw-semibold heading-color text-sm lg:text-base">Con Tarjeta de
                                            Credito</span>
                                    </div>
                                </label>
                                <div>
                                    <input name="payOptions" type="radio" id="estandar1" class="mr-4">
                                </div>
                            </div>
                            <div class="flex items-center justify-between border rounded-md">
                                <label for="estandar2" class="grid w-full p-4">
                                    <div class="flex items-center">
                                        <BaseIcon :path="mdiCashMultiple" :size="40" :w="20" :h="20"
                                            class="text-green-600 mr-3" />
                                        <span class="fw-semibold heading-color text-sm lg:text-base">Pago en
                                            Efectivo</span>
                                    </div>
                                </label>
                                <div>
                                    <input name="payOptions" type="radio" id="estandar2" class="mr-4">
                                </div>
                            </div>
                            <div class="flex items-center justify-between border rounded-md">
                                <label for="estandar3" class="grid w-full p-4">
                                    <div class="flex items-center">
                                        <BaseIcon :path="mdiBank" :size="40" :w="20" :h="20"
                                            class="text-green-600 mr-3" />
                                        <span class="fw-semibold heading-color text-sm lg:text-base">Via
                                            Transferencia</span>
                                    </div>
                                </label>
                                <div>
                                    <input name="payOptions" type="radio" id="estandar3" class="mr-4">
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </div> -->
            <!-- Lista de pedidos tabla -->
            <!-- <div class="container sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                <div class="grid grid-cols-1 lg:grid-cols-6 gap-4 bg-white rounded-lg overflow-hidden shadow-lg">
                    <div class="col-span-6 p-6 pb-0">
                        <h1 class="text-gray-900 text-xl font-bold">Listado de Pedidos
                        </h1>
                    </div>
                    <div class="col-span-6">
                        <div class="overflow-x-auto w-full">
                            <div class="table w-full h-full min-w-[600px] ">
                                <div class="table-header-group h-10">
                                    <div class="table-row bg-gray-700 text-white gap-2 text-xs lg:text-base py-2 px-2">
                                        <div class="table-cell text-center align-middle">Factura</div>
                                        <div class="table-cell text-center align-middle">Fecha</div>
                                        <div class="table-cell text-center align-middle">Limite de Pago</div>
                                        <div class="table-cell text-center align-middle">Importe Total</div>
                                        <div class="table-cell text-center align-middle">Recibido</div>
                                        <div class="table-cell text-center align-middle">Resta por cobrar</div>
                                        <div class="table-cell text-center align-middle">Importe de Pago</div>
                                    </div>
                                </div>
                                <div class="table-row-group">
                                    <div class="table-row text-center text-xs lg:text-base bg-white">
                                        <div class="table-cell align-middle border-b border-r border-l py-2">Factura
                                        </div>
                                        <div class="table-cell align-middle border-b border-r py-2">Fecha</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Limite de Pago</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Importe Total</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Recibido</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Resta por Cobrar
                                        </div>
                                        <div class="table-cell align-middle border-b border-r py-2">Importe de Pago
                                        </div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-base bg-gray-50">
                                        <div class="table-cell align-middle border-b border-r border-l py-2">Factura
                                        </div>
                                        <div class="table-cell align-middle border-b border-r py-2">Fecha</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Limite de Pago</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Importe Total</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Recibido</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Resta por Cobrar
                                        </div>
                                        <div class="table-cell align-middle border-b border-r py-2">Importe de Pago
                                        </div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-base bg-white">
                                        <div class="table-cell align-middle border-b border-r border-l py-2">Factura
                                        </div>
                                        <div class="table-cell align-middle border-b border-r py-2">Fecha</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Limite de Pago</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Importe Total</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Recibido</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Resta por Cobrar
                                        </div>
                                        <div class="table-cell align-middle border-b border-r py-2">Importe de Pago
                                        </div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-base bg-gray-50">
                                        <div class="table-cell align-middle border-b border-r border-l py-2">Factura
                                        </div>
                                        <div class="table-cell align-middle border-b border-r py-2">Fecha</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Limite de Pago</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Importe Total</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Recibido</div>
                                        <div class="table-cell align-middle border-b border-r py-2">Resta por Cobrar
                                        </div>
                                        <div class="table-cell align-middle border-b border-r py-2">Importe de Pago
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-span-6 p-6 pt-0">
                        <div class="flex items-center justify-center mb-4">
                            <input id="default-checkbox" type="checkbox" value=""
                                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2">
                            <label for="default-checkbox"
                                class="ml-2 text-sm text-gray-900 dark:text-gray-300">Clasificar
                                automáticamente todas las facturas
                                estándar, de
                                anticipo o de reemplazo como "Pagadas" cuando el pago se
                                realice por completo.</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container sm:px-6 lg:px-8 px-4 mx-auto mb-10">
                <div class="flex justify-between">
                    <button class="btn btn-gray btn-ico justify-center">
                        <span class="mr-2">BORRAR</span>
                        <BaseIcon :path="mdiBroom" />
                    </button>
                    <button class="btn btn-green btn-ico justify-center">
                        <span class="mr-2">CREAR PEDIDO</span>
                        <BaseIcon :path="mdiCheckBold" />
                    </button>
                        
                </div>
            </div> -->
        </div>
    </BreezeAuthenticatedLayout>
</template>
